// extracted by mini-css-extract-plugin
module.exports = {"view-btn":"view-btn___RUTn1"};